export { Eyebrow } from './Eyebrow';
export { EyebrowEnum, type EyebrowProps } from './Eyebrow.types';
